import { Component, OnInit,ViewChild } from '@angular/core';
import { CavaliService } from 'app/services/Cavali/Cavali.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter ,MAT_DATE_FORMATS,MAT_DATE_LOCALE} from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { LoginService } from "../../services/login/login.service";
import Swal from "sweetalert2";
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-registrar-radian',
  templateUrl: './registrar-radian.component.html',
  styleUrls: ['./registrar-radian.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class RegistrarRadianComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns : string[] = ['Check','idComprobante','Proveedor','Adquirente','Fecha_Registro','TipoComprobante','TipoEmision','Documento','Moneda','VNPPICLV','FechaEmision','FechadePagoICLV','Estado','Comentario'];
  
  dataSource : any; 

  proveedoresArr : any;
  adquirentesArr : any;

  loading : boolean;

  documentosN : any = [];
  arraySend: any = [];

  filteredProveedores : Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;

  filterForm =  new FormGroup({
    provFilter: new FormControl(''),
    adqFilter: new FormControl(''),
    
    tipoFilter: new FormControl(''),
    idProvFilter: new FormControl(''),
    idAdqFilter: new FormControl(''),
    estadoFilter: new FormControl(''),
    procesoFilter: new FormControl(''),
    tipoFechaFilter: new FormControl(''),
    fromDate: new FormControl(),
    toDate: new FormControl()
  });

  filterValues = {
    Tipo: '',
    Proveedor: '',
    Adquirente: '',
    Estado: '',
    Proceso: '',
    Fecha: '',
    From: '',
    To: ''
  };

  constructor(private cavaliService : CavaliService,private loginService:LoginService, private router:Router, private datepipe:DatePipe) {
    this.obtenerProveedoresCombo(); 
    this.obtenerAdquirentesCombo();
    this.listarDocumentosN();
  }

  ngOnInit() {
    this.filterForm.get('tipoFilter').valueChanges.subscribe(
      tipo => {
        this.filterValues.Tipo = tipo;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('idProvFilter').valueChanges.subscribe(
      idProveedor => {
        this.filterValues.Proveedor = idProveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('idAdqFilter').valueChanges.subscribe(
      idAdquirente => {
        this.filterValues.Adquirente = idAdquirente;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    ); 
    this.filterForm.get('estadoFilter').valueChanges.subscribe(
      estado => {
        this.filterValues.Estado = estado;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('procesoFilter').valueChanges.subscribe(
      proceso => {
        this.filterValues.Proceso = proceso;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('tipoFechaFilter').valueChanges.subscribe(
      fecha => {
        this.filterValues.Fecha = fecha;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('fromDate').valueChanges.subscribe(
      from => {
        this.filterValues.From = (from === null ? "" : this.datepipe.transform(from, 'yyyy-MM-dd'));
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    this.filterForm.get('toDate').valueChanges.subscribe(
      to => {
        this.filterValues.To = (to === null ? "" : this.datepipe.transform(to, 'yyyy-MM-dd')); 
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
  }

  registrarDocumentosCavali(){
  if(this.arraySend.length>0){
    Swal.fire({
      title: 'Factrack - Cavali',
      html: '¿Deseas registrar <b>'+this.arraySend.length+'</b> documento(s) en la plataforma Cavali?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.loginService.clickGuard = true;
        let total = this.arraySend.length;
        let ini = 0;
        this.arraySend.forEach(element => {
          this.cavaliService.registrarCavali(element.idComprobante).subscribe(
            resp =>{
              this.showNotification('success','top','right','Documento Nro '+element.idComprobante+' enviado satisfactoriamente a Cavali.');
              ini++;
              if(ini == total) this.router.navigate(['/cavali/listado']);
            },err => {
              let error = "";
              error = err.error.error;
              this.showNotification('warning','top','right','No se pudo enviar el documento Nro '+element.idComprobante+' a Cavali para su registro. \n Error: ' + error);
              ini++;
              if(ini == total) this.router.navigate(['/cavali/listado']);
            }
          )
        })
       
      }
    })
  } else {
      Swal.fire({
        title: 'Espera',
        text: 'Seleccione al menos un documento.',
        type: 'warning',
        heightAuto: false
      })
  }  
  }

  limpiar(){
    if(this.arraySend.length == 0){
      this.documentosN.map(object => object.checked = true);
      this.arraySend = this.documentosN.filter(
        dato => (dato.Estado_Cavali == '4' || (dato.Estado_Cavali == '3' && dato.Codigo_Respuesta.toString() != '0000'))
      );
    } else {
      this.arraySend = [];
      this.documentosN.map(object => object.checked = false);
    }
  }

  Agregar(element: any){
    if(element.checked){
      this.arraySend.push(element);
    } else {
      this.arraySend = this.arraySend.filter(function(dato){
        if (dato.idComprobante == element.idComprobante) {
          return false;
        } else {
          return true;
        }
      })
    }   
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Tipo_Comprobante.toString().toUpperCase().indexOf(searchTerms.Tipo) !== -1
              && data.idProveedor === (searchTerms.Proveedor == "" ? data.idProveedor : searchTerms.Proveedor)
              && data.idAdquirente === (searchTerms.Adquirente == "" ? data.idAdquirente : searchTerms.Adquirente)
              && data.Estado.toString().toUpperCase().indexOf(searchTerms.Estado) !== -1
              && data.Estado_Cavali === (searchTerms.Proceso == "" ? data.Estado_Cavali : (searchTerms.Proceso == "0" ? "3" : searchTerms.Proceso))
              
              && data.Codigo_Respuesta == (searchTerms.Proceso == "" ? data.Codigo_Respuesta : (searchTerms.Proceso == "3" ? '0000' : data.Codigo_Respuesta))
              && data.Codigo_Respuesta != (searchTerms.Proceso == "" ? "1234" : (searchTerms.Proceso == "0" ? '0000' : "1234"))
              
              && data.Fecha_Registro >= (searchTerms.Fecha == "T" ? (searchTerms.From == "" ? data.Fecha_Registro : searchTerms.From) : data.Fecha_Registro)
              && data.Fecha_Registro <= (searchTerms.Fecha == "T" ? (searchTerms.To == "" ? data.Fecha_Registro : searchTerms.To) : data.Fecha_Registro)

              && data.Fecha_Emision >= (searchTerms.Fecha == "E" ? (searchTerms.From == "" ? data.Fecha_Emision : searchTerms.From) : data.Fecha_Emision)
              && data.Fecha_Emision <= (searchTerms.Fecha == "E" ? (searchTerms.To == "" ? data.Fecha_Emision : searchTerms.To) : data.Fecha_Emision)

              && data.Fecha_de_Pago_ICLV >= (searchTerms.Fecha == "P" ? (searchTerms.From == "" ? data.Fecha_de_Pago_ICLV : searchTerms.From) : data.Fecha_de_Pago_ICLV)
              && data.Fecha_de_Pago_ICLV <= (searchTerms.Fecha == "P" ? (searchTerms.To == "" ? data.Fecha_de_Pago_ICLV : searchTerms.To) : data.Fecha_de_Pago_ICLV)
    }
    return filterFunction;
  }

  listarDocumentosN(){
    this.loading = true;
    this.cavaliService.listarDNegociables().subscribe(
      resp=>{
          this.documentosN = resp['data'];
          this.dataSource = new MatTableDataSource(this.documentosN);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.dataSource.filterPredicate = this.createFilter();
          this.loading = false;
      },err => {
        this.loading = false;
      }
    )
  }

  obtenerProvId(provId :string){
    this.filterForm.get('idProvFilter').setValue(provId);
  }

  obtenerAdqId(adqId :string){
    this.filterForm.get('idAdqFilter').setValue(adqId);
  }

  obtenerRucRazSocialProv(termino: string = ''){
    if (termino != null && termino != ''){
      termino = termino.toLowerCase();                  
      for(let p of this.proveedoresArr){
        let raz = p.Razon_Social.toLocaleLowerCase();
        let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.filterForm.get('idProvFilter').setValue(p.idEmpresa);
          this.filterForm.get('provFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.filterForm.get('idProvFilter').setValue('');
      this.filterForm.get('provFilter').setValue('');
    }
  }

  obtenerRucRazSocialAdq(termino: string = ''){
    if (termino != null && termino != ''){          
      termino = termino.toLowerCase();                
      for(let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
          let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.filterForm.get('idAdqFilter').setValue(p.idEmpresa);
          this.filterForm.get('adqFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.filterForm.get('idAdqFilter').setValue('');
      this.filterForm.get('adqFilter').setValue('');
    }
  }

  obtenerProveedoresCombo(){
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveedores = this.filterForm.get('provFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProv(state) : this.proveedoresArr.slice())
    );   
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  obtenerAdquirentesCombo(){
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.filterForm.get('adqFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterAdq(state) : this.adquirentesArr.slice())
    );  
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  downloadInformation(element){
    Swal.fire({
      title: 'Factrack - Cavali',
      html: '¿Deseas descargar información del documento <b>Nro '+element.idComprobante+'</b> desde la plataforma Cavali?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Si',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.loginService.clickGuard = true;
        this.cavaliService.downloadInformation(element.idComprobante).subscribe(
          resp =>{
            this.showNotification('success','top','right','Se descargó correctamente la información del documento Nro '+element.idComprobante+' desde la plataforma Cavali.');
            this.router.navigate(['/cavali/listado']);
          },err => {
            let error = "";
            error = err.error.error;
            this.showNotification('warning','top','right','No se pudo descargar la información del documento Nro '+element.idComprobante+'.\n Error: ' + error);
            this.router.navigate(['/cavali/listado']);
          }
        )         
      }
    })
  }

  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}
